<template>
  <div class="main">
    <date></date>
    <div class="headerTop"></div>

    <backBtn></backBtn>
    <div class="activeTitle" style="margin-top: 60px">装饰装修</div>

    <div class="banner">
      <div class="tabs">
        <!-- <div class="tabspan" @click="viewDialog(1)">
          <img
            style="
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 10px;
            "
            src="../../assets/images/ico_btn@2x.png"
            alt=""
          />政策文件
        </div> -->
        <div class="tabspan" @click="viewDialog(2)">
          <img
            style="
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 10px;
            "
            src="../../assets/images/ico_btn@2x.png"
            alt=""
          />办理流程
        </div>
        <div class="tabspan1" @click="viewDialog(3)">
          <img
            style="
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 10px;
            "
            src="../../assets/images/ico_btn_3@2x.png"
            alt=""
          />办事指南
        </div>
      </div>
    </div>
    <!-- 正在装修 -->

    <div class="toushu">
      <div class="systemTitle" style="width: 500px">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;正在装修
      </div>
      <zzzxTable></zzzxTable>
    </div>
    <div class="toushu">
      <div class="systemTitle" style="width: 500px">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;装修巡检
      </div>
      <zxxjTable></zxxjTable>
    </div>
    <div class="toushu">
      <div class="systemTitle" style="width: 500px">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;装饰装修整改
      </div>
      <wjbgTable></wjbgTable>
    </div>
    <el-dialog
     
      :visible.sync="dialogVisible"
      :width="dialogWidth"
    >
      <div class="dialog_title">{{ dialogTitle }}</div>
      <div v-html="zsnr" class="zsnrcontent"></div>
      <!-- <div v-if="dialogType == 1" class="container">
        <p style="text-align: center">
          （2003年2月10日四川省人民政府令第168号发布　自2003年4月l日起施行）
        </p>
        <h2>第一章　总　则</h2>
        <p>
          <b>第一条</b
          >　为加强建筑装饰装修活动的管理，保障建筑装饰装修的质量和公共安全，维护装饰装修活动当事人的合法权益，根据《中华人民共和国建筑法》、《建设工程质量管理条例》和《四川省建筑管理条例》等法律、法规，结合四川省实际，制定本办法。
        </p>
        <p>
          <b>第二条</b>
          　在四川省行政区域内从事建筑装饰装修活动以及有关行政管理，应当遵守本办法。
        </p>
        <p>
          <b> 第三条</b>
          　本办法所称建筑装饰装修，是指为使建筑物、构筑物达到一定的环境质量和使用要求，使用装饰装修材料，对外表和内部进行修饰处理的建筑活动，包括建筑工程装饰装修和城镇住宅室内装饰装修。
        </p>
        <p>
          <b> 第四条</b
          >　建筑装饰装修应当保证质量，确保安全，体现美观，符合城市规划、消防、市容市貌等相关规定和标准。鼓励采用先进技术、先进工艺、新型材料。
        </p>
        <p>
          <b>第五条</b>　省建设行政主管部门对全省建筑装饰装修实施统一监督管理。
        </p>
        <p>
          市、州、县（市、区）建设行政主管部门依照本办法的规定对本行政区域内的建筑工程装饰装修实施监督管理，市、州、县（市、区）房地产行政主管部门依照本办法的规定对本行政区域内的城镇住宅室内装饰装修实施监督管理。
        </p>
        <h2>第二章　一般规定</h2>
        <p>
          <b> 第六条 </b
          >　从事建筑装饰装修的企业应当按照国家有关规定取得省以上建设行政主管部门颁发的资质证书，并在其资质等级许可的范围内承揽工程。
        </p>
        <p>
          <b> 第七条 </b>
          　建筑装饰装修不得拆改建筑主体结构、承重结构或者明显加大荷载。确需拆改或者加大荷载的，应当经原设计单位或者具有相应资质等级的设计单位对装饰装修设计方案的安全性进行审定后，方可进行装饰装修。
        </p>
        <p>
          <b> 第八条 </b>
          　建筑装饰装修应当依据施工图设计文件施工。施工中需要修改设计文件的，应当经原设计单位或者具有相应资质等级的设计单位修改，其中，对经审查批准的设计文件进行修改的，必须报原审查单位审查批准。
        </p>
        <p>
          <b>第九条</b>
          　建筑装饰装修应当保证建筑物、构筑物的整体性、抗震性和结构安全，严格执行装饰装修的质量标准，遵守有关施工和安全的强制性规范。
        </p>
        <p>危险房屋或者验收不合格的房屋不得装饰装修。</p>
        <p>
          <b> 第十条 </b
          >　建筑装饰装修改动卫生间、厨房间防水层的，应当符合防水标准，并做闭水试验。
        </p>
        <p>
          <b>第十一条</b
          >　用于建筑装饰装修的材料和设备应当符合设计要求和产品质量标准，必须有质量检验合格证明。禁止偷工减料，禁止使用不合格的或者国家明令淘汰的材料和设备。
        </p>
        <p>
          <b> 第十二条 </b>
          　建筑装饰装修应当采取措施，加强对易燃材料物品的管理，严格遵守操作规程，做好安全防范工作；控制施工现场的各类粉尘、有害气体、固体废弃物、噪音、振动等对环境的污染和危害。
        </p>
        <p>
          <b> 第十三条</b
          >　建筑装饰装修装修人（以下简称装修人）和装饰装修施工方应当签订建筑装饰装修书面合同，明确双方的权利、义务。
          　建筑装饰装修书面合同应当包括以下主要内容：
        </p>
        <p>（一）双方当事人的姓名或者名称、地址、联系方式；</p>
        <p>
          （二）装饰装修项目的地址、位置、房屋间数、建筑面积；装饰装修的内容、方式、规格、质量要求及验收方式；
        </p>
        <p>（三）开工、竣工时间；</p>
        <p>（四）项目的保修内容、期限；</p>
        <p>（五）价格，计价和支付方式、时间；</p>
        <p>（六）合同变更和解除的条件；</p>
        <p>（七）违约责任及解决纠纷的途径；</p>
        <p>（八）合同的生效时间；</p>
        <p>（九）双方认为需要明确的其他条款。</p>
        <p>建筑装饰装修书面合同格式，由省建设行政主管部门统一规定。</p>
        <p>
          <b>第十四条</b
          >　建筑装饰装修竣工后，装修人应当按照装饰装修合同约定和相应的质量标准进行验收。验收合格后，装饰装修施工方应当出具装饰装修质量保修书。保修期限按国家有关规定执行；双方约定超过国家规定的保修期限的，按双方约定执行。
        </p>
        <p>
          <b> 第十五条 </b
          >　建筑装饰装修发生纠纷的，当事人可以协商解决，不愿协商或者协商不成的，可以依法申请仲裁或者向人民法院起诉。
        </p>
        <p>
          <b>第十六条</b
          >　任何单位和个人对建筑装饰装修中出现的影响公众利益的质量事故、质量缺陷以及其他影响周围住户、用户正常工作、生活的行为，有权检举、投诉、控告。
        </p>
        <h2>第三章　建筑工程装饰装修</h2>
        <p>
          <b>第十七条</b
          >　建筑工程装饰装修应当根据工程规模及特殊要求，选择具有相应资质等级的企业进行，发包时不得压级压价，不得将一个建设工程项目肢解后发包。
        </p>
        <p><b>第十八条</b>下列建筑工程项目的装饰装修必须进行招标：</p>
        <p>（一）大型基础设施、公用事业等关系社会公共利益、公共安全的项目；</p>
        <p>（二）全部或者部分使用国有资金投资或者国家融资的项目；</p>
        <p>（三）使用国际组织或者外国政府贷款、援助资金的项目。</p>
        <p>
          前款所列项目的具体范围和规模标准，按国家和省人民政府的有关规定执行。装修人不得将建筑工程装饰装修项目肢解，规避招标管理。
        </p>
        <p>
          <b>第十九条</b
          >　建筑装饰装修企业应当自行组织完成承包的建筑工程装饰装修项目，不得转包和违法分包，严禁挂靠承包。
        </p>
        <p>
          <b> 第二十条</b
          >　凡投资30万元以上，或者涉及建筑物、构筑物结构安全或者公共安全的建筑工程装饰装修项目，在开工前装修人必须向工程所在地的县级以上建设行政主管部门申请领取施工许可证、与主体工程一并发包的建筑工程装饰装修项目应当随主体工程一并办理施工许可手续。
        </p>
        <p>装修人不得将建筑工程装饰装修项目肢解，规避施工许可管理。</p>
        <p>
          <b>第二十一条</b
          >　装修人申请领取施工许可证，应当具备下列条件，并提供相应的证明文件：
        </p>
        <p>（一）已经确定装饰装修施工企业；</p>
        <p>
          （二）有满足施工需要的施工图纸及技术资料，施工图设计文件已经按规定进行了审查；
        </p>
        <p>
          （三）有保证装饰装修质量和安全的具体措施，并按规定办理了工程质量、安全监督和消防审核等手续；
        </p>
        <p>（四）按规定应当委托监理的，已经委托监理；</p>
        <p>（五）装饰装修资金已经落实；</p>
        <p>（六）法律、法规规定的其他证明文件。</p>
        <p>
          <b>第二十二条</b
          >　装修人对建筑工程装饰装修项目验收合格后，应当在15日内将有关资料报建设行政主管部门和其他有关部门备案。
        </p>
        <h2>第四章　住宅室内装饰装修</h2>
        <p><b>第二十三条</b>　住宅室内装饰装修应当遵守本办法第二章规定。</p>
        <p>
          <b> 第二十四条</b
          >　装修人依法享有住宅室内装饰装修自主权。任何单位或者个人不得对装修人指定装饰装修单位和强制推销装饰装修材料。
        </p>
        <p>
          鼓励装修人选择具有相应资质等级的装饰装修企业承接住宅室内装饰装修。
        </p>
        <p>
          非业主的住宅使用人对住宅室内进行装饰装修，必须征得业主的书面同意。
        </p>
        <p>
          <b> 第二十五条 </b
          >装饰装修施工应当将产生噪声、振动等工序的时段妥善安排，避开周围住户正常的休息时间。产生的建筑垃圾应当及时清运，妥善处置，不得乱丢乱倒。
        </p>
        <p>
          <b>第二十六条</b
          >　装饰装修施工人员及装饰装修材料进出住宅区，应当遵守房屋管理单位的有关规定。
        </p>
        <p>
          <b>第二十七条</b
          >　房屋管理单位有权对住宅室内装饰装修活动进行监督。发现装修人或者装饰装修施工方违反本办法有关规定的，应当予以制止、责令改正或者报告有关部门查处。
        </p>
        <p>
          <b> 第二十八条</b
          >　在正常使用条件下，住宅室内装饰装修质量的最低保修期限为2年，有防水要求的厨房、卫生间和外墙面的防渗漏期为5年。保修期自住宅室内装饰装修竣工验收合格之日起计算。
        </p>
        <p>
          <b> 第二十九条 </b
          >　因装饰装修活动造成相邻住宅的管道堵塞、渗漏水、停水停电、物品毁坏等，装修人应当负责修复和赔偿；属装饰装修施工方责任的，装修人可以向其追偿。
        </p>
        <h2>第五章　法律责任</h2>
        <p>
          <b> 第三十条</b
          >　违反本办法规定，无证或者超越资质等级从事建筑工程装饰装修的，由县级以上建设行政主管部门给予警告，责令停止违法行为，没收违法所得，可并处项目造价0.5%至2%的罚款；情节严重的，降低资质等级或者吊销资质证书。
        </p>
        <p>
          <b> 第三十一条</b
          >　违反本办法规定，末按规定办理建筑工程装饰装修项目施工许可证擅自动工的，或者擅自修改施工图设计文件并影响房屋结构安全的，由县级以上建设行政主管部门给予警告，责令限期改正；逾期不改正的，处以2万元罚款。
        </p>
        <p>
          <b>第三十二条</b
          >　违反装饰装修的质量标准、施工和安全等强制性规范的，或者拆改建筑主体结构、承重结构或者明显加大荷载的．由县级以上建设或者房地产行政主管部门给予警告，责令停止施工，并可处项目合同价2%至4%的罚款；情节严重的，降低资质等级或者吊销资质证书。
        </p>
        <h2>第六章　附　则</h2>
        <p>
          <b>第三十三条</b
          >　具有文物保护价值的建筑、古建筑以及军事设施工程、保密设施工程的装饰装修依照有关规定执行。
        </p>
        <p>
          <b> 第三十四条</b
          >　本办法所称建筑主体结构，是指建筑实体的结构构造，包括屋盖、楼盖、梁、柱、支撑、承重墙体、连接接点和基础等。
        </p>
        <p>
          本办法所称承重结构，是指直接将本身自重与各种外加作用力系统地传递给基础地基的主要结构构件和其连接接点，包括承重墙体、立杆、柱、框架柱、支墩、楼板、梁、屋架、悬索等。
        </p>
        <p><b>第三十五条</b>　本办法自2003年4月l日起施行。</p>
      </div>

      <div class="container" v-else-if="dialogType == 2">
        <img src="../../assets/images/zhuangshi1.png" alt="" />
      </div>
      <div class="container" v-else>
        <p><b>1. 目的</b></p>
        <p>规范客户装修管理工作，保障装修的规范施工。</p>
        <p><b>2. 适用范围</b></p>
        <p>适用于住宅管理中心各在管项目。</p>
        <p><b>3. 定义</b></p>
        <p>
          装修管理：是指物业服务企业依据《住宅室内装饰装修管理办法》、《管理规约》对所辖区域内的装修活动实施监督管理。
        </p>
        <p>
          <b>4. 职责</b>
        </p>
        <p>4.1 项目负责人负责业主装修申请的审批，对装修管理工作进行监督。</p>
        <p>
          4.2
          工程部为装修管理工作的主责部门，负责装修图纸申请的审核，装修施工过程进行
          监督，进行装修竣工验收。
        </p>
        <p>
          4.3
          客服部负责装修手续的办理和资料的管理，并与工程部共同行使装修施工过程监督工作。
        </p>
        <p>
          4.4
          秩序部负责装修人员及材料出入管理、装修现场安全管理和装修施工时间进行控制。
        </p>
        <p><b>5. 方法和过程控制</b></p>
        <p>5.1 装修申请</p>
        <p>
          （1）
          业主携带本人身份证原件（为便于确认业主身份），到物业服务中心办理申请手续，客服人员引导业主将装修事项详细填写在《装修申请备案表》中。
          （2）
          业主委托他人办理装修申请手续，应提交业主身份证（结婚证、户口本等）复印件和委托人身份证原件及《装修授权委托书》，并现场电话确认。
          （3） 租户办理装修手续，应出具业主同意装饰装修的授权委托书。 （4）
          业主、租户、业主装修委托人需签订《装饰装修管理规定》、《封闭阳台承诺书》、《装饰装修承诺书》等。
        </p>
        <p>5.2 装修办理流程</p>
        <p>
          （1）
          客服部将业主装修方案（如装修图纸、装修公司相关资质证件等）提交物业工程部审核。
          （2）
          装修方案经过核对同意后，客服部引导业主及装修公司与物业服务中心签订《装修管理协议》，就其中的装修禁止项进行告知，并由施工单位确定施工负责人及防火责任人，需动火的需填写《特种作业申请表》。
          （3）
          客服部引导业主缴纳相关装修费用（装修保证金、垃圾清运费、出入证工本费等）。
          （4） 客服部凭财务收据发放《装修许可证》。（5）
          装修手续办理流程图：<br />
          <img src="../../assets/images/zhuangshizhuangxiu.png" alt="" />
        </p>
        <p>5.3 装修监管</p>
        <p>
          （1）
          业主装修应保障楼宇结构安全及管线、设备正常的使用，维护园区外观的统一，
          因此要求项目客服部、工程部、秩序部对业主装修情况进行监管巡查（新交付项目从集中交付开始执行），具体如下：
        </p>
        <p>客服部：</p>
        <p>
          a.
          巡查频次：对已办理装修手续业主的装修情况进行监管巡查，每周至少对区域内所有装修施工现场全覆盖检查一次。
          b.
          检查内容：包括但不限于业主装修手续办理情况（如检查装修许可证）、装修垃圾清运、是否存在刺激性气味和粉尘影响相邻业主生活或小区环境、房屋外立面是否统一、电气线路违规乱接等违章装修行为。
          c.
          每次巡查需在装修户门外张贴的《装修房巡查签到表》进行签到，巡查完后完善
          《装修房巡查记录表》，发现有违章行为应立马进行劝阻、制止，并及时和现场施工人员、施工单位负责人、业主进行沟通，需限期整改恢复的应开具《整改通知书》，并跟进整改恢复情况。
          d.负责在新项目交付前依据提供模板拟定《装修违禁材料清单》，并在园区出入口、园区内进行公示。
        </p>
        <p>工程部：</p>
        <p>
          a.巡查频次：对已办理装修手续业主的装修情况进行监管巡查，每周至少对区域内所有装修施工现场全覆盖检查一次。
          b.检查内容：包括但不限于拆改承重墙、房屋外立面、扩大门窗尺寸、更改房屋主体结构、电气线路违规乱接等影响建筑结构和使用安全的行为，装修申请内容是否与现场一致。
          c.每次巡查需在装修户门外张贴的《装修房巡查签到表》进行签到，巡查完后完善
          《装修房巡查记录表》，发现有违章行为应立马进行劝阻、制止、上报物业中心。
        </p>
        <p>秩序部：</p>
        <p>
          a.巡查频次：对已办理装修手续业主的装修情况进行监管巡查，每周至少对区域内所有装修施工现场全覆盖检查一次。
          b.检查内容：包括但不限于检查施工人员出入证、是否闭门施工、动火作业是否提
          前申请、是否配备足量、足压力的消防设备器材、是否有消防安全隐患、是否有人员留宿/煮食现象、装修时间、噪音施工等。
          c.每次巡查需在装修户门外张贴的《装修房巡查签到表》进行签到，并将巡查情况记录在《装修房巡查记录表》，发现有违规行为应立马进行劝阻、制止，上报物业中心。
          d.秩序部负责对园区进出的装修违禁材料进行监管，一经发现装修违禁材料（如：违规保险窗、钢筋、角钢等建筑材料）立即制止车辆进入园区，并及时上报客户中心协调处理。
        </p>
        <p>（2） 装修注意事项：</p>
        <p>
          a. 加强对人员的管理，不得乱窜楼层，保证环境卫生。 b.
          要认真检查施工证件是否齐全有效。对于无装修手续的，应现场停工，要求现场装修负责人或业主到客服中心接洽处理。
          c.
          发现有违规操作情况要立即制止,若沟通不畅及时通知秩序领班或秩序负责人现场协调处理。
          d. 改动卫生间、阳台须重新做防水处理，并经 48
          小时以上闭水试验。不得封闭排水检查孔，不得将污水管接入雨水管。 e.
          装修期所有装修垃圾、材料等物料都须存放在户内，物业公共区域禁止放置施工材料及装修垃圾，装修企业需自行把装修垃圾、材料打好包装运到指定堆放点。
          f. 规定可进行装修工程之时间为【星期一至星期五（夏季：08:00-12:00 和
          14:00-18:00），（冬季：8:30-12:00和13：30-17:30）】【周末（夏季：
          08:00-12:00 和
          14:00-18:00），（冬季：8:30-12:00和13:30-17:30）允许静音施工】，法定节假日禁止施工（具体装修施工时间可参照当地政府规定要求执行）。
          g.
          除以上装修管理注意事项以外，具体参照《住宅室内装饰装修管理办法》及《装修管理协议》执行。
        </p>
        <p>5.4 装修验收</p>
        <p>
          装修竣工结束，由工程部人员依据装修备案、业主申报提供的装修图纸和小区管理规约对房屋结构、房屋外立面、防水试水等房屋装修成品进行第一次现场验收，若有异常情况需要求装修公司整改。
          (2)
          装修竣工满3个月后，由客服部统一安排工程人员依据施工方案和小区管理规定
          配合业主和施工单位负责人进行现场复验，由业主和装修施工单位负责人确认验收结果，并由业主在《房屋装修验收单》上签字认可。
          （1） 对不合格项需限期进行整改，并进行复验，至合格为止。 （2）
          由业主在《房屋装修验收单》上签字确认后，由业主或装修负责人凭保证金缴纳收据到物业服务中心办理退还房屋装修保证金手续。
        </p>
        <p>5.5 成品保护</p>
        <p>（1） 装修高峰期间成品保护：</p>
        <p>
          a. 园区易造成污染的石材地面，采用彩条布、软布等软性材料进行铺装保护。
          b. 楼栋大厅地面（含电梯前室）、墙面 1.2m
          需采用彩条布、软布等软性材料进行铺装保护。 c.
          电梯轿厢内壁需采用木工板进行保护。（项目协调交付前完成） d.
          每层电梯前室墙面棱角需进行成品保护，尽量采用防撞软性材料。 e.
          装修业主入户门外壁、门前 1.2m
          以内需进行成品保护，材料由装修公司或业主自行提供、选择。 f.
          园区/车库指定堆放装修建材、装修建渣位置，地面应用彩条布、木工板等材料做好保护。
          （2） 成品保护管理要求： a.
          项目负责人应编制有关成品保护的管理规定；同时根据现场情况编写成品保护方案，报企业发展中心品质管理部进行审核、审批。
          b. 项目负责人对外委施工单位成品保护方案进行审核并提出修改意见。 c.
          项目客服部负责每天对现场成品保护情况进行巡查，在现场巡查中如发现成品遭到污染或损坏，有权要求当事人立即停止，并限期做好成品保护。
          d. 成品保护遵循谁施工谁负责的原则。 e.
          秩序部负责对装修人员和车辆的行进路线进行要求和监管，避免人员车辆失控损毁公共设施。
        </p>
        <p>5.6 围合管理</p>
        <p>（1） 装修围合标准（主要适用于别墅、洋房、底商）：</p>
        <p>
          a. 材质：绿色森林喷绘布或蓝色彩钢板。 b. 高度：高度不低于 1.8 米，建议
          2 米，同一项目应保持统一高度。 c.
          外观：表面无广告信息，整洁平整。d．内侧：内侧必须设置支撑条。
          e．位置：须在自家花园或车库边界范围内，二楼及以上在窗户或阳台边界以内，不得占用公共区域，不得影响相邻户位。
        </p>
        <p>（2） 施工围合标准：</p>
        <p>
          a.
          项目内部施工、外委施工单位施工，要求对施工区域进行围合，采用彩条布、彩钢板等。
          b.
          项目应提前三日在施工区域公示施工原因、施工整改期限、施工整改责任人等信息。
          c.
          项目应在施工区域周边人行通道设置安全警示牌，必要时还需增加警戒带，如“
          正在施工，请绕行”、“高空作业，请注意安全”等。
        </p>
        <p>（3） 装修围合管理原则：</p>
        <p>
          a．先告知要求，后验证结果。b．先做好围挡后进场装修。c．加强巡查及时提醒。
        </p>
        <p>（4） 施工围合管理原则：</p>
        <p>
          针对园区大型整改，且整改时间较长，应提前三日告知业主，且需通过公告、通知、短信、微信等形式向业主传达施工信息，以避免造成业主的不理解。
        </p>
        <p>
          （5）
          项目工程部负责每天对现场装修、施工围合情况进行巡查，园区/楼道/车库的装修围合、施工围合必须保证现场的品质感，效果呈现可控。
        </p>
        <p>6. 其他</p>
        <p>6.1 本办法由公司品质管理部负责编制、修订、补充和解释。</p>
        <p>6.2 本办法自发布之日起生效实施。</p>
        <p>7. 附录</p>
        <p>
          7.1 JHWY/ZZ-KH-22 《室内装饰装修备案表》 <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.2 JHWY/ZZ-KH-23 《装饰装修管理规定》
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.3 JHWY/ZZ-KH-24 《房屋装饰装修管理协议》
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.4 JHWY/ZZ-KH-25 《封闭阳台承诺书》
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.5 JHWY/ZZ-KH-26 《装饰装修承诺书》
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.6 JHWY/ZZ-KH-27 《装修许可证》 <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.7 JHWY/ZZ-KH-28
          《房屋装饰装修竣工验收单》 <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.8 JHWY/ZZ-KH-29 《室内装修现场巡查表》
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.9 JHWY/ZZ-KH-30 《违规行为整改通知单》
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.10 JHWY/ZZ-KH-31 《违章处理记录表》
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.11 JHWY/ZZ-KH-32
          《装修违禁材料清单》（模板） <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.12 JHWY/ZZ-KH-33 《装修房巡查签到表》
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.13 JHWY/ZZ-KH-34 《装修授权委托书》
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;7.14 JHWY/ZZ-KH-75 《特种作业申请表》
        </p>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import backBtn from "../../components/back/index.vue";
import zzzxTable from "../Table/zzzxTable.vue";
import zxxjTable from "../Table/zxxjTable.vue";
import wjbgTable from "../Table/wjbgTable.vue";
import date from "../../components/header/index.vue";
import api from "@/api/repair.js";

export default {
  name: "",
  components: { backBtn, zzzxTable, zxxjTable, wjbgTable, date },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "",
      dialogType: null,
      dialogWidth: "",
      zsnr: "",
    };
  },
  created() {},
  methods: {
    viewDialog(type) {
      let zslx = 0;
      if (type == 1) {
        this.dialogTitle = "四川省建筑装饰装修管理办法";
        this.dialogWidth = "80%";
        zslx = 4;
      } else if (type == 2) {
        this.dialogTitle = "装饰装修流程";
        this.dialogWidth = "65%";
        zslx = 5;
      } else {
        this.dialogTitle = "泸州市欣亿家物业装修管理规范";
        this.dialogWidth = "80%";
        zslx = 6;
      }
      api
        .getInfo({
          zslx: zslx,
        })
        .then((res) => {
          if (res.data.code == 200 && res.data.data) {
            this.dialogVisible = true;
            this.dialogType = type;
            this.zsnr = decodeURIComponent(res.data.data.zsnr);
          } else {
            this.$message.warning("暂无数据");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.zsnrcontent {
  height: 650px;
  overflow-y: scroll;
  margin-top: 30px;
  &::-webkit-scrollbar {
    width: 1px;
  }
}
.banner {
  height: 104px;
  border-radius: 16px;
  border: 1px solid #005070;
  margin: 40px 0;
  .tabs {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    .tabspan {
      width: 48%;
      height: 55px;
      line-height: 55px;
      background: linear-gradient(135deg, #098ea8 0%, #1fb28d 100%);
      border-radius: 204px;
      border: 2px solid rgba(83, 255, 226, 0.6588);
      margin-top: 20px;
      margin-right: 20px;
      cursor: pointer;
    }
    .tabspan1 {
      width: 48%;
      line-height: 55px;
      height: 56px;
      background: linear-gradient(135deg, #3479d0 2%, #2c98bc 100%);
      border-radius: 204px;
      border: 2px solid #1bd9ff;
      cursor: pointer;
      margin-top: 20px;
    }
  }
}
.toushu {
  height: 440px;
  margin-top: 20px;
  background: linear-gradient(
    154deg,
    rgba(0, 132, 255, 0.66) 0%,
    rgba(62, 126, 246, 0) 100%
  );
  border-radius: 24px;
  border: 2px solid #70e2ee;

  padding: 20px;
}

::v-deep .el-dialog {
  height: 800px;
  background: url("../../assets/images/dialog_bg2.png");
  background-size: 100% 100%;
  border-radius: 24px;

  color: #fff;
  position: relative;
  overflow: hidden;
}

::v-deep .el-dialog h1 {
  font-size: 26px;
  color: #fff;
}
::v-deep .el-dialog h2 {
  color: #fff;
  text-align: center;
}
::v-deep .el-dialog p {
  text-indent: 2em;
  color: #fff;
  font-size: 18px;
  padding: 0 20px;
  line-height: 29px;
}
::v-deep .el-dialog__title {
  color: #fff;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 24px;
}

.dialog_title {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  min-width: 285px;
  height: 46px;
  color: #fff;
  background-size: 100% 100%;
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  line-height: 46px;
  margin-top: 20px;
}

.container {
  height: 650px;
  overflow-y: scroll;
  margin-top: 30px;
}
</style>
